/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/// Converts Snowflake Data Types to JavaScript Data Types
/// ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export function snowflakeToJsTypes(value: any, type: string) {
  if (value === null) {
    return null; // Snowflake NULL maps directly to JavaScript null
  }

  if (type === null || type === undefined) {
    return value; // if no type is given, return the value as is.
  }

  const normalizedType = type.toUpperCase();

  switch (normalizedType) {
    case 'NUMBER':
    case 'DECIMAL':
    case 'INTEGER':
    case 'BIGINT':
    case 'SMALLINT':
    case 'TINYINT':
    case 'FLOAT':
    case 'DOUBLE':
    case 'REAL':
    case 'FIXED':
      return Number(value);
    case 'BOOLEAN':
      return value === 'true' || value === true || value === 1 || value === '1';
    case 'DATE':
      if (typeof value === 'string') {
        return new Date(value);
      } else {
        return value; // if it is already a date, return it.
      }
    case 'TIME':
      if (typeof value === 'string') {
        // Time is often returned as a string.
        // There is no direct Javascript time type, so we return the string.
        return value;
      } else {
        return value;
      }
    case 'TIMESTAMP_NTZ':
    case 'TIMESTAMP_LTZ':
    case 'TIMESTAMP_TZ':
      if (typeof value === 'string') {
        return new Date(parseFloat(value) * 1000);
      } else {
        return value;
      }
    case 'VARCHAR':
    case 'STRING':
    case 'TEXT':
      return String(value);
    case 'BINARY':
      if (typeof value === 'string') {
        //Binary data is typically returned as a base64 encoded string.
        try{
          return atob(value);
        } catch(e){
          return value; //If atob fails, return the string.
        }
      } else {
          return value;
      }
    case 'VARIANT':
    case 'OBJECT':
    case 'ARRAY':
      try {
        if (typeof value === 'string') {
          return JSON.parse(value);
        } else {
          return value; // If it's already an object or array, return it.
        }

      } catch (e) {
        console.error('Error parsing JSON:', e);
        return value; // Return the original value if parsing fails.
      }
    default:
      return value; // Return the original value for unknown types.
  }
}